const IS_PROD = process.env.NODE_ENV === 'production';

// Register the /sw.js service worker
export function registerServiceWorker() {
  return IS_PROD;
}
